import { render, staticRenderFns } from "./userManager.vue?vue&type=template&id=631830c0"
import script from "./userManager.vue?vue&type=script&lang=js"
export * from "./userManager.vue?vue&type=script&lang=js"
import style0 from "./userManager.vue?vue&type=style&index=0&id=631830c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports